import { render, staticRenderFns } from "./data.vue?vue&type=template&id=344c20b9&scoped=true"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"
import style0 from "../../style/common-m.scss?vue&type=style&index=0&id=344c20b9&prod&lang=scss&scoped=true&external"
import style1 from "./data.vue?vue&type=style&index=1&id=344c20b9&prod&lang=css"
import style2 from "./data.vue?vue&type=style&index=2&id=344c20b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c20b9",
  null
  
)

export default component.exports